import { render } from "./product-delivery-charges.vue?vue&type=template&id=c4d9ccb2"
import script from "./product-delivery-charges.vue?vue&type=script&lang=js"
export * from "./product-delivery-charges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__